
export class InitReportCommand {
    constructor(
        private readonly features_provider,
        private readonly feature_name,
        private screen_data
    ) {}

    async run(user) {
        try {
            let cmd_has_feature = await this.features_provider.got_feature(this.feature_name, user)
            this.screen_data.has_feature = cmd_has_feature
            
        } catch (error) {
            this.screen_data.has_feature = ''
            console.error("Error checking user feature", error)
        }
    }
}